
class LicenseAccountInfoCell extends UITableViewCell
{
    private payMethodDropdown:MUIButton = null;
    private bankAccountDropdown:MUIButton = null;

    awakeFromHTML(): void {
        this.payMethodDropdown = MUIOutlet( this, "pay-method-dd", "MUIButton");
        this.payMethodDropdown.setAction(this, function(this:LicenseAccountInfoCell) {
            AppHelper.sharedInstance().showSelectPaymethodViewControllerFromView( this.payMethodDropdown, this.businessLicense?.payMethod, this, function(this:LicenseAccountInfoCell, controller:any, object:PayMethod){
                this.businessLicense.payMethod = object;
                this.payMethodDropdown.title = object.name;
            });
        });

        this.bankAccountDropdown = MUIOutlet( this, "bank-account-dd", "MUIButton");
        this.bankAccountDropdown.setAction(this, function(this:LicenseAccountInfoCell) {
            AppHelper.sharedInstance().showSelectBankInfoViewControllerFromView( this.bankAccountDropdown, this.businessLicense?.client, this, function(this:LicenseAccountInfoCell, controller:any, object:BankAccountInfo){
                this.businessLicense.bankAccountInfo = object;
                this.bankAccountDropdown.title = object.number;
            });
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private businessLicense:BusinessLicense = null;
    set item(item:BusinessLicense) {
        this.businessLicense = item;

        this.payMethodDropdown.title = item?.payMethod?.name;
        this.bankAccountDropdown.title = item?.bankAccountInfo?.number;
    }
}